
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.04 12.702a2.006 2.006 0 01-2.006 2.005H4.01a2.006 2.006 0 01-2.005-2.005v-9.36c0-1.107.898-2.005 2.005-2.005h6.686l.007.007c.47.04.912.245 1.248.58l1.5 1.5c.336.336.54.779.58 1.249l.007.007v8.022zm-2.006.668H4.01c-.369 0-.668-.299-.668-.668v-9.36c0-.369.3-.668.668-.668h6.017v1.337c0 .739.599 1.337 1.337 1.337h1.337v7.354c0 .37-.3.668-.668.668z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.69 6.685a.669.669 0 00-1.337 0v1.337H6.016a.669.669 0 100 1.337h1.337v1.337a.669.669 0 001.337 0V9.36h1.337a.669.669 0 000-1.337H8.69V6.685z","fill":"currentColor"}})])
          )
        }
      }
    